import {
    getToken,
    setToken,
    getUserInfo,
    setUserInfo,
    removeUserInfo,
    removeToken
} from '@/utils/auth'
import request from '@/utils/request'
import {
    MessageBox
} from 'element-ui'
import APP from '@/utils/base'
const REGION_ROUTER = {
    '1': 'routerDefault', // 重庆市建委 默认
    '2': 'routerDefault', // 重庆市两江新区 默认
    '4': 'routerDefault', // 永川普天 默认
    '5': 'routerDefault', // 渝高 默认
    '1,18': 'routerDefault', // 重庆市建委（温华） 默认
    '20': 'routerCq3', // 重庆市建委3.0
    '1,22': 'routerCqCt', // 重庆市建委 + 城投
    '2,22': 'routerCqCt', // 重庆两江新区 + 城投
    '20,22': 'routerCq3Ct', // 重庆市建委3.0 + 城投
    '1,5': 'routerDefault', // 重庆市建委 + 渝高
    '2,5': 'routerDefault', // 重庆市两江新区 + 渝高
    '5,20': 'routerDefault', // 重庆市建委3.0 + 渝高

    '3': 'routerCd', // 成都市建委
    '15': 'routerCdjg', // 成都建工
    '3,15': 'routerCdjg', // 成都市建委+成都建工
    '3,16': 'routerCd', // 成都市建委+成都环境投资

    '12': 'routerGzs', // 贵州省人社厅
    '19': 'routerGy', // 贵阳市建委
    '12,19': 'routerGy', // 贵州省人社厅 + 贵阳市建委
    '23': 'routerGzzj', // 贵州省住建厅
    '12,23': 'routerGzzj', // 贵州省人社厅 + 贵州省住建厅

    '24': 'routerHn', // 海南市建委
    '25': 'routerLz', // 泸州

    '28': 'routerCqmohrss', // 重庆市人社局
    '1,28': 'routerCqmohrss', // 重庆市人社局 + 重庆市建委
    '2,28': 'routerCqmohrss', // 重庆市人社局 + 重庆两江新区
    '20,28': 'routerCqmohrssCq3', // 重庆市人社局 + 重庆市建委1.0

    '1,29': 'routerDefault', // 重庆市高新区 + 重庆市建委
    '20,29': 'routerCq3', // 重庆市高新区 + 重庆市建委1.0
    '1,28,29': 'routerCqmohrss', // 重庆市高新区 + 重庆市人社局 + 重庆市建委
    '20,28,29': 'routerCqmohrssCq3', // 重庆市高新区 + 重庆市人社局 + 重庆市建委1.0

    '31': 'routerCq2', // 重庆市建委2.0
    '22,31': 'routerCq2', // 重庆市建委2.0 + 城投
    '29,31': 'routerCq2', // 重庆市建委2.0 + 重庆市高新区
    '28,31': 'routerCq2Cqmohrss', // 重庆市建委2.0 + 重庆市人社局
    '28,29,31': 'routerCq2Cqmohrss', // 重庆市建委2.0 + 重庆市人社局 + 重庆市高新区
    '2,28,31': 'routerCq2Cqmohrss', // 重庆市建委2.0 + 重庆市人社局 + 重庆市两江新区

    '32': 'routerGztr', // 贵州省铜仁市建委
    '12,32': 'routerCq2Cqmohrss', // 贵州省铜仁市建委 + 贵州省人社厅

    '34': 'routerGld', // 广联达
    '2,34': 'routerGld', // 广联达 + 重庆市两江新区
    '28,34': 'routerGld', // 广联达 + 重庆市人社局
    '31,34': 'routerGld', // 广联达 + 重庆市建委2.0
    '2,28,34': 'routerGld', // 广联达 + 重庆市两江新区 + 重庆市人社局
    '28,31,34': 'routerGld', // 广联达 + 重庆市建委2.0 + 重庆市人社局

    '31,35': 'routerCq2Zjygjxm', // 重庆市建委2.0 + 中交一公局厦门公司
    '28,31,35': 'routerCq2Zjygjxm', // 重庆市建委2.0 + 中交一公局厦门公司

    '37': "routerQzy", // 轻筑云
    '2,37': "routerQzy", // 轻筑云 + 重庆市两江新区
    '28,37': "routerQzy", // 轻筑云 + 重庆市人社局
    '31,37': "routerQzy", // 轻筑云 + 重庆市建委2.0
    '2,28,37': "routerQzy", // 轻筑云 + 重庆市两江新区 + 重庆市人社局
    '28,31,37': "routerQzy", // 轻筑云 + 重庆市建委2.0 + 重庆市人社局

    '38': "routerHx", // 华西
    '2,38': "routerHx", // 华西 + 重庆市两江新区
    '28,38': "routerHx", // 华西 + 重庆市人社局
    '31,38': "routerHx", // 华西 + 重庆市建委2.0
    '2,28,38': "routerHx", // 华西 + 重庆市两江新区 + 重庆市人社局
    '28,31,38': "routerHx", // 华西 + 重庆市建委2.0 + 重庆市人社局

    '12,39': 'routerGzzjkj', // 贵州省人社厅+中建

    '41': 'routerQb', // 千变
    '2,41': 'routerQb', // 千变 + 重庆市两江新区
    '28,41': 'routerQb', // 千变 + 重庆市人社局
    '31,41': 'routerQb', // 千变 + 重庆市建委2.0
    '2,28,41': 'routerQb', // 千变 + 重庆市两江新区 + 重庆市人社局
    '28,31,41': 'routerQb', // 千变 + 重庆市建委2.0 + 重庆市人社局

    '46': 'routerCdjgGld', // 成都建工-广联达版
    '2,46': 'routerCdjgGld', // 成都建工-广联达版 + 重庆市两江新区
    '28,46': 'routerCdjgGld', // 成都建工-广联达版 + 重庆市人社局L
    '31,46': 'routerCdjgGld', // 成都建工-广联达版 + 重庆市建委2.0
    '2,28,46': 'routerCdjgGld', // 成都建工-广联达版 + 重庆市两江新区 + 重庆市人社局
    '28,31,46': 'routerCdjgGld', // 成都建工-广联达版 + 重庆市建委2.0 + 重庆市人社局

    '47': 'routerCqdc2', // 重庆地产2.0
    '2,47': 'routerCqdc2', // 重庆地产2.0 + 重庆市两江新区
    '28,47': 'routerCqdc2', // 重庆地产2.0 + 重庆市人社局
    '31,47': 'routerCqdc2', // 重庆地产2.0 + 重庆市建委2.0
    '2,28,47': 'routerCqdc2', // 重庆地产2.0 + 重庆市两江新区 + 重庆市人社局
    '28,31,47': 'routerCqdc2', // 重庆地产2.0 + 重庆市建委2.0 + 重庆市人社局

    '48': 'routerCqddk', // 重庆市大渡口区
    '2,48': 'routerCqddk', // 重庆市大渡口区 + 重庆市两江新区
    '28,48': 'routerCqddk', // 重庆市大渡口区 + 重庆市人社局
    '31,48': 'routerCqddk', // 重庆市大渡口区 + 重庆市建委2.0
    '2,28,48': 'routerCqddk', // 重庆市大渡口区 + 重庆市两江新区 + 重庆市人社局
    '28,31,48': 'routerCqddk', // 重庆市大渡口区 + 重庆市建委2.0 + 重庆市人社局

    '50': 'routerCq2Cqmohrss2', // 重庆人社局2.0
    '31,50': 'routerCq2Cqmohrss2', // 重庆人社局2.0 + 重庆市建委2.0
    // '29,31,50': 'routerCq2Cqmohrss', // 重庆人社局2.0 + 重庆市建委2.0 + 重庆市高新区
    // '2,31,50': 'routerCq2Cqmohrss', // 重庆人社局2.0 + 重庆市建委2.0 + 重庆市两江新区
    '34,50': 'routerGld', // 重庆人社局2.0 + 广联达
    // '2,34,50': 'routerGld', // 重庆人社局2.0 + 广联达 + 重庆市两江新区
    '31,34,50': 'routerGld', // 重庆人社局2.0 + 广联达 + 重庆市建委2.0
    // '31,35,50': 'routerCq2Zjygjxm', // 重庆人社局2.0 + 重庆市建委2.0 + 中交一公局厦门公司
    '37,50': 'routerQzy', // 重庆人社局2.0 + 轻筑云
    // '2,37,50': 'routerQzy', // 重庆人社局2.0 + 轻筑云 + 重庆市两江新区
    '31,37,50': 'routerQzy', // 重庆人社局2.0 + 轻筑云 + 重庆市建委2.0
    // '38,50': 'routerHx', // 重庆人社局2.0 + 华西
    // '2,38,50': 'routerHx', // 重庆人社局2.0 + 华西 + 重庆市两江新区
    // '31,38,50': 'routerHx', // 重庆人社局2.0 + 华西 + 重庆市建委2.0
    // '41,50': 'routerQb', // 重庆人社局2.0 + 千变
    // '2,41,50': 'routerQb', // 重庆人社局2.0 + 千变 + 重庆市两江新区
    // '31,41,50': 'routerQb', // 重庆人社局2.0 + 千变 + 重庆市建委2.0
    // '46,50': 'routerCdjgGld', // 重庆人社局2.0 + 成都建工-广联达版
    // '2,46,50': 'routerCdjgGld', // 重庆人社局2.0 + 成都建工-广联达版 + 重庆市两江新区
    // '31,46,50': 'routerCdjgGld', // 重庆人社局2.0 + 成都建工-广联达版 + 重庆市建委2.0
    // '47,50': 'routerCqdc2', // 重庆人社局2.0 + 重庆地产2.0
    // '2,47,50': 'routerCqdc2', // 重庆人社局2.0 + 重庆地产2.0 + 重庆市两江新区
    // '31,47,50': 'routerCqdc2', // 重庆人社局2.0 + 重庆地产2.0 + 重庆市建委2.0
    // '48,50': 'routerCqddk', // 重庆人社局2.0 + 重庆市大渡口区
    // '2,48,50': 'routerCqddk', // 重庆人社局2.0 + 重庆市大渡口区 + 重庆市两江新区
    // '31,48,50': 'routerCqddk', // 重庆人社局2.0 + 重庆市大渡口区 + 重庆市建委2.0

    '51': 'routerQzy', // 重庆市建委3.0
    '31,51': 'routerQzy', // 重庆市建委3.0 + 重庆市建委2.0
    '50,51': 'routerQzy', // 重庆市建委3.0 + 重庆人社局2.0
    '31,50,51': 'routerQzy', // 重庆市建委3.0 + 重庆市建委2.0+ 重庆人社局2.0
    '37,51': 'routerQzy', // 重庆市建委3.0 + 轻筑云
    '31,37,51': 'routerQzy', // 重庆市建委3.0 + 轻筑云 + 重庆市建委2.0
    '31,37,50,51': 'routerQzy', // 重庆市建委3.0 + 轻筑云 + 重庆市建委2.0 + 重庆人社局2.0
    '34,51': 'routerGld', // 重庆市建委3.0 + 广联达
    '31,34,51': 'routerGld', // 重庆市建委3.0 + 广联达 + 重庆市建委2.0
    '31,34,50,51': 'routerGld', // 重庆市建委3.0 + 广联达 + 重庆市建委2.0 + 重庆人社局2.0
}
const Util = {
    // 外部登录时，设置Token及缓存
    fnSetLoginInfo: function(_data) {
        if (!_data) return false
        let _token = getToken()
        let _url = location.href.split('?')[0]

        _data = JSON.parse(_data)
        let _region = _data.region

        if (_region) {
            let _regionArrDivision = _region.split(',')
            let _regionArr = []
            for (let i = 0; i < _regionArrDivision.length; i++) {
                if (_regionArrDivision[i] === '' ||
                    _regionArrDivision[i] === '5' ||
					_regionArrDivision[i] === '21' ||
                    _regionArrDivision[i] === '30'||
                    _regionArrDivision[i] === '40'||
                    _regionArrDivision[i] === '42') {
                    continue;
                }
                _regionArr.push(_regionArrDivision[i])
            }
            _regionArr = _regionArr.sort((a, b) => {
                return a - b
            })
            _region = _regionArr.join(',')
        }

        if (REGION_ROUTER.hasOwnProperty(_region) || _region === '') {
            if (!_token || _token == 'undefined') {
                setToken(_data.token)
                setUserInfo(_data)
                location.reload()
                return false
            }
            let _userInfo = getUserInfo()
            // 如果已存在token，判断是否为同一用户
            if (_userInfo && (_userInfo.id == _data.id)) {
                setToken(_data.token)
                setUserInfo(_data)
                location.href = _url + '?t=' + new Date().getTime()
                return false
            }
            // MessageBox.confirm('您已在当前网站登录，确定要覆盖之前登录信息？', '提示', {
            // 	confirmButtonText: '确定',
            // 	cancelButtonText: '取消',
            // 	center: true
            // }).then(() => {
            setToken(_data.token)
            setUserInfo(_data)
            location.reload()
            return false
            // }).catch(() => {
            // 	return false
            // })
        } else {
            setToken(_data.token)
            setUserInfo(_data)
            // 如果区域不是默认也不是路由中的其他路由，调用方法跳转至原项目端
            APP.goProject()
            return
        }
    }
}

export default Util



// WEBPACK FOOTER //
// ./src/utils/util.js